import { Helmet } from "react-helmet-async";

export default function SEO({ title, description, path = "" }) {
  const fullTitle = title
    ? `${title} | Visiovet`
    : "Visiovet | Diagnóstico por Imagem Veterinário em Belo Horizonte";
  const desc =
    description ||
    "Centro de diagnóstico por imagem veterinária em Belo Horizonte. Ressonância magnética, tomografia, ultrassom e raio-x para cães e gatos.";
  const url = `https://www.visiovet.com.br${path}`;
  return (
    <Helmet>
      <html lang="pt-BR" />
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:locale" content="pt_BR" />
      <link rel="canonical" href={url} />
    </Helmet>
  );
}
